import { TableCell } from "@mui/material";

import withStyles from '@mui/styles/withStyles';

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: theme.palette.common.black,
    backgroundColor: "#FFFFFF",
  },
  body: {
    fontSize: 14,
    fontWeight:500,
    color:"#4B4B4B"
  },
}))(TableCell);

export default StyledTableCell;